define('tdproducttobasket', ['jquery', 'wamodal', 'wanotifications', 'waajax'], function ($, wamodal, wanotifications, waajax) {

    var tdproducttobasket = {

        docBody: $('body'),
        moveCssClass: 'js_move',
        productFullinfo: $('.product__fullinfo'),
        chooseVariantClassName: 'js_chooseFirst',
        noScrollClass: 'js_noscroll',
        basketSlide: $('.basket__slide'),
        fastBuyBtn: $('.js_fastBuyBtn'),
        modalCloseBtn: $('.js_modalClose'),

        // Product to Basket
        js_submitBasket: function js_submitBasket() {
            var _this = this;

            this.productFullinfo.on('mouseover', '.js_submitBasket', function (e) {
                _this.currentBasketButton = $(e.currentTarget);
                // this.checkInputFields('hover');
            }).on('mouseout', '.js_submitBasket', function () {
                !!_this.currentBasketButton ? _this.currentBasketButton.removeClass(_this.chooseVariantClassName) : "";
            }).on('click', '.js_submitBasket', function (e) {
                _this.checkBasket('click');
            });

            //Additional Product Ajax Call
            $(document).on('change', '.additional__form select', function (e) {
                e.preventDefault();
                _this.basketAjax(e.currentTarget.form, 1);
            });
            //Fast View Modal Ajax Call
            $(document).on('click', '.js_submitFastViewBasket', function (e) {
                var viewMsg = false;
                var self = $(e.currentTarget);
                var formID = self.data('form');
                var formSelect = self.parent().find('.additional__select');
                var formSelectValue = !!formSelect ? formSelect.find(":selected").val() : false;

                formSelect.on('change', function (e) {
                    viewMsg = false;
                    $(e.currentTarget).removeClass('js_error');
                });

                if (!!formSelectValue && formSelectValue != 'noselect') {
                    $('#' + formID + ' option').prop('selected', false);
                    $('#' + formID + ' option[value=\'' + formSelectValue + '\']').prop('selected', true);
                }
                if (!!formSelectValue && formSelectValue == 'noselect') {
                    viewMsg = "choseAllSlects";
                }

                //view msg
                if (viewMsg) {
                    wanotifications.msg(wamessages[wamessages.actLang][viewMsg], 'error');
                    formSelect.addClass('js_error');
                } else {
                    _this.basketAjax($('#' + formID), 1, self, 1);
                }
            });
            //Additional Product Ajax Call
            $(document).on('click', '.additional__form [type="submit"]', function (e) {
                e.preventDefault();
                _this.basketAjax(e.currentTarget.form, 1);
            });
        },
        basketAjax: function basketAjax(formName, additionalProduct) {

            var basketFormButton = $('#FormSubmit');
            var basketBoxSmall = $('.js_basketBoxSmall');

            if (parseInt(basketFormButton.data('buyable')) === 1 || !!additionalProduct) {
                var form = $(formName);

                // Prototype.js works better with serialize (for example, it handles space correctly)
                var postData = form[0].serialize();

                var formURL = form.attr("action");
                var currentBasketNumber = parseInt($('.navigation__circle.cart').text());
                var classNames = {
                    "load": "js_sendAjax",
                    "success": "js_sendAjaxSuccess",
                    "error": "js_sendAjaxError"
                };

                if (!additionalProduct) {
                    basketFormButton.addClass(classNames.load);
                } else {
                    form.parent().addClass(classNames.load);
                }

                var addToCartButton = $$('.product__tobasket.js_submitBasket').first();
                if (addToCartButton && addToCartButton.hasAttribute('disabled')) {
                    addToCartButton.classList.remove('js_sendAjax');
                    return false;
                }

                new EasyAjax.Request(formURL, {
                    method: 'post',
                    action_content: ['minicart_wrapper', 'basket.slide'],
                    parameters: postData,
                    onComplete: function onComplete(transport) {
                        var response = transport.responseJSON;
                        if (response) {
                            var messages = response.messages;
                            var actionContent = response['action_content_data'];
                            if (actionContent) {
                                var cartNewData = actionContent['minicart_wrapper'];
                                var newBasketSliderHTML = actionContent['basket.slide'];

                                if (cartNewData) {

                                    cartNewData = jQuery(cartNewData);
                                    newBasketSliderHTML = jQuery(newBasketSliderHTML);

                                    jQuery('.js_basketReplace').replaceWith(cartNewData);

                                    tdproducttobasket.basketSlider(newBasketSliderHTML.find('.js_basketSlideReplace').html());

                                    if (!additionalProduct) {
                                        basketFormButton.removeClass(classNames.load).addClass(classNames.success).stop().delay(1000).queue(function () {
                                            basketFormButton.removeClass(classNames.success);
                                        });

                                        basketBoxSmall.removeClass(classNames.load).addClass(classNames.success).stop().delay(5000).queue(function () {
                                            basketBoxSmall.removeClass(classNames.success);
                                        });
                                    } else {
                                        form.parent().removeClass(classNames.load) && wanotifications.msg(wamessages[wamessages.actLang]['inBasket'], 'success');
                                    }
                                } else {
                                    wanotifications.msg(wamessages[wamessages.actLang]['notBuyableArticle'], 'error');
                                }
                            }
                            if (messages && messages[0] && messages[0].type == 'success') {
                                var generatedInfo = getAddToCartInfo();
                                if (generatedInfo) {
                                    var cartInfo = jQuery.extend({
                                        id: 0,
                                        price: 0,
                                        qty: 0,
                                        name: '',
                                        currency: 'CHF'
                                    }, generatedInfo);

                                    // fbq('track', 'AddToCart', {
                                    //     value: cartInfo['price'],
                                    //     currency: cartInfo['currency'],
                                    //     contents: [
                                    //         {
                                    //             id: cartInfo['id'],
                                    //             quantity: cartInfo['qty']
                                    //         }
                                    //     ],
                                    //     content_type: cartInfo['category_path']
                                    // });
                                }

                                if (typeof getAddToCartDataLayerInfo === 'function') {
                                    var dataLayerInfo = getAddToCartDataLayerInfo();
                                    var currency = '';
                                    if (typeof currencyCode !== 'undefined') {
                                        currency = currencyCode;
                                    } else {
                                        currency = 'CHF';
                                    }

                                    window.dataLayer = window.dataLayer || [];
                                    dataLayer.push({ ecommerce: null });
                                    dataLayer.push({
                                        'event': 'addToCart',
                                        'ecommerce': {
                                            'currencyCode': currency,
                                            'add': {
                                                'products': [dataLayerInfo]
                                            }
                                        }
                                    });
                                }
                            }
                        }
                        $('.custom__modal').hide();
                    }
                });
            } else {
                wanotifications.msg(wamessages[wamessages.actLang]['notBuyableArticle'], 'error');
            }
        },
        basketSlider: function basketSlider(newBasketSliderHTML) {
            var _this2 = this;

            var currentBasketSlide = $('.basket__slide');

            if (!currentBasketSlide) return;
            this.basketSlide.addClass(this.moveCssClass).find('.js_basketSlideReplace').html(newBasketSliderHTML);

            window.isTouchDevice == false ? $(".basket__formular--wrapper").mCustomScrollbar({ axis: "y", theme: "dark-2" }) : '';

            if (window.customproduct) {
                $('#customGenerateMessage').fadeOut();
                //$('.basket__productimage > img').attr('src', $('#finalCustomPicure').attr('src'));
            }

            $('.basket__slide--background, .basket__slide--close').on('click', function () {
                _this2.basketSlide.removeClass(_this2.moveCssClass);
            });
        },
        crosssellAjax: function crosssellAjax(formName) {
            var form = $(formName);
            var basketFormButton = form.find('.crosssell--submit').eq(0);
            var basketBoxSmall = $('.js_basketBoxSmall');

            if (parseInt(basketFormButton.data('buyable')) === 1) {
                // Prototype.js works better with serialize (for example, it handles space correctly)
                var postData = form[0].serialize();

                var formURL = form.attr("action");
                var currentBasketNumber = parseInt($('.navigation__circle.cart').text());
                var classNames = {
                    "load": "js_sendAjax",
                    "success": "js_sendAjaxSuccess",
                    "error": "js_sendAjaxError"
                };

                basketFormButton.addClass(classNames.load);

                new EasyAjax.Request(formURL, {
                    method: 'post',
                    action_content: ['minicart_wrapper'],
                    parameters: postData,
                    onComplete: function onComplete(transport) {
                        var response = transport.responseJSON;
                        if (response) {
                            var messages = response.messages;
                            var actionContent = response['action_content_data'];
                            if (actionContent) {
                                var cartNewData = actionContent['minicart_wrapper'];
                                if (cartNewData) {
                                    cartNewData = jQuery(cartNewData);
                                    jQuery('.js_basketReplace').replaceWith(cartNewData.find('.js_basketReplace'));

                                    basketFormButton.removeClass(classNames.load).addClass(classNames.success).stop().delay(1000).queue(function () {
                                        basketFormButton.removeClass(classNames.success);
                                    });

                                    basketBoxSmall.removeClass(classNames.load).addClass(classNames.success).stop().delay(5000).queue(function () {
                                        basketBoxSmall.removeClass(classNames.success);
                                    });
                                } else {
                                    wanotifications.msg(wamessages[wamessages.actLang]['notBuyableArticle'], 'error');
                                }
                            }
                        }

                        wamodal.close(true);
                    }
                });
            } else {
                wanotifications.msg(wamessages[wamessages.actLang]['notBuyableArticle'], 'error');
            }
        },
        setPhoneCat: function setPhoneCat() {
            var phoneCatField = $('[name="phonecat"]');
            if (!phoneCatField.length) return;
            if (window.sessionStorage) {
                sessionStorage.setItem('waphonefield', '1');
            }
        },
        setBasketAnimation: function setBasketAnimation() {
            var navigationList = $('.header__account, .header__basket');
            var visibleClassName = 'js_visible';

            navigationList.mouseenter(function () {

                if (window.wabreakpoint == 'small' || $('main').hasClass('basket')) return;

                var self = $(this);
                var navBox = self.find('.navigation__box--wrapper');
                navBox.addClass(visibleClassName);

                if (navBox.children().hasClass('basket')) {
                    navBox.find('.basket__message--products').addClass(visibleClassName) && $(".js_scrollProducts").mCustomScrollbar({
                        axis: "y",
                        theme: "dark-2"
                    });
                }
            }).mouseleave(function () {
                $('.' + visibleClassName).removeClass(visibleClassName);
            });
        },
        checkInputFields: function checkInputFields(triggerEvent) {

            var self = tdproducttobasket;
            var viewMsg = false;
            $(".dropDown p > span > span > span").each(function () {
                if ($(this).hasClass('noselect')) {
                    viewMsg = "choseAllSlects";
                    if (triggerEvent !== 'hover') $(this).closest('.dropDown').addClass('js_error');
                } else {
                    $(this).closest('.dropDown').removeClass('js_error');
                }
            });

            $('#SCPcustomOptionsDiv input').not('.floor-calc-length, .floor-calc-width').each(function () {
                if (this.value.length === 0) {
                    viewMsg = "choseAllSlects";
                    $(this).addClass('js_error');
                } else {
                    $(this).removeClass('js_error');
                }
            });

            $(".product-options select option:selected").each(function () {
                if (this.value.length === 0) {
                    viewMsg = "choseAllSlects";
                    $(this).parent().addClass('js_error');
                } else {
                    $(this).parent().removeClass('js_error');
                }
            });

            $(".product__colors--choosed").each(function () {
                if ($(this).hasClass('noselect')) {
                    viewMsg = "choseAllSlects";
                }
            });

            $(".product-custom-option").each(function () {
                if ($(this).hasClass('validation-failed')) {
                    viewMsg = "choseAllSlects";
                    $(this).parent().addClass('js_error');
                } else {
                    $(this).parent().removeClass('js_error');
                }
            });

            return viewMsg;
        },
        checkBasket: function checkBasket(triggerEvent) {
            var _this3 = this;

            var viewMsg = this.checkInputFields(triggerEvent);

            if (viewMsg) {
                this.chooseUserMessage(true);
                return false;
            } else {
                this.setPhoneCat();
                if (triggerEvent === 'click') {

                    if (window.customproduct) {
                        return window.customproduct.finalize(function () {
                            return _this3.basketAjax('.product__form');
                        });
                    }

                    this.basketAjax('.product__form');
                }
            }
        },
        chooseUserMessage: function chooseUserMessage(status) {
            if (!!status) {
                this.currentBasketButton.addClass(this.chooseVariantClassName);
            }
        },
        init: function init() {
            this.js_submitBasket();
        }
    };

    window.tdproducttobasket = tdproducttobasket;
    return tdproducttobasket;
});

